/* eslint-disable prettier/prettier */
import Translations from '@helpers/translations'
import htmr from 'htmr'
import { StaticPageDef } from 'types/pages'

export const SIZES_TEXT = {
  buildText: {
    A: Translations.localise('common.sizes.build-a-desc'),
    B: Translations.localise('common.sizes.build-b-desc'),
    C: Translations.localise('common.sizes.build-c-desc')
  },
  taperText: {
    Skinny:
      'Our slimmest taper below the knee for a tighter fit around the calves.',
    Slim: Translations.localise('common.sizes.taper-slim-desc'),
    Standard: Translations.localise('common.sizes.taper-standard-desc'),
    Straight: Translations.localise('common.sizes.taper-straight-desc')
  }
} as const

export const SIZES = {
  waist: [
    '28',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '37',
    '38',
    '40',
    '42',
    '44',
    '46'
  ],
  build: ['Build A', 'Build B', 'Build C'],
  pack: ['Single', '2 Pack', '3 Pack'],
  taper: ['Slim', 'Standard', 'Straight'],
  leg: ['28', '29', '30', '31', '32', '33', '34', '35', '36', '37'],
  size: ['S', 'M', 'M+', 'L', 'L+', 'XL', 'XXL'],
  'chest size': ['36', '38', '40', '42', '44', '46', '48'],
  SizeVerbose: ['Small', 'Medium', 'Medium+', 'Large', 'Large+', 'XL', 'XXL'],
  cut: ['Slim', 'Straight'],
  length: ['Short', 'Regular', 'Long'],
  shortsleg: ['3', '5', '7', '9', '11'],
  sizeSocks: ['S/M', 'M/L']
} as const

export const FINISHED_TO_ORDER = 'Finished to Order'
export const WAIST = 'Waist'
export const BUILD = 'Build'
export const LEG = 'Leg'
export const SIZE = 'Size'
export const CHEST_SIZE = 'Chest Size'
export const CUT = 'Cut'
export const LENGTH = 'Length'
export const SHORTSLEG = 'ShortsLeg'
export const TAPER = 'Taper'
export const SWIMSHORTSLEG = 'swimshortsleg'
export const SHOW_COLLECTION_PRODUCT_TYPE = ['blue order', 'taper']
export const PRODUCTION_PATH = 'https://spoke-london.com'
export const STAGING_PATH = 'https://spoke-staging.com'
export const TROUSERS = 'trousers'
export const TOPS = 'tops'
export const SHORTS = 'shorts'
export const MTO_TAG = 'tax:MTO'
export const LOWER_LEG_SLIM_SHORT = 'Slim Short'
export const LOWER_LEG_SLIM_LONG = 'Slim Long'
export const LOWER_LEG_SLIM_SHORT_SKU = '03'
export const LOWER_LEG_SLIM_LONG_SKU = '04'
export const MAX_MTO_VARIANT_QUANTITY = 10
export const SIZE_CHART_TOP_SORT_ORDER = [
  'XS',
  'S',
  'M',
  'M+',
  'L',
  'L+',
  'XL',
  'XXL',
  'XXXL'
]

export const ADDITIONAL_PROPERTIES = {
  taper: {
    helperButton: true,
    skipInCookies: true,
    type: 'taper'
  },
  build: {
    helperButton: false,
    type: 'build',
    skipInCookies: false
  },
  ignoreSizeOptionType: {
    helperButton: false,
    skipInCookies: true
  }
} as const

export const NO_SHOW_ATTRIBUTES_PROPS = [
  '_add-on',
  '_introducing',
  '_addedToCartTimestamp',
  '_mto'
] as const

export const GIFT_CARD = {
  hero: {
    mobile: '//cdn.shopify.com/s/files/1/0207/9406/files/GiftPageMobile.jpg',
    desktop: '//cdn.shopify.com/s/files/1/0207/9406/files/GiftPageDesktop.jpg',
    tablet: '//cdn.shopify.com/s/files/1/0207/9406/files/GiftPageTablet.jpg'
  },
  sidebar: [
    'https://cdn.shopify.com/s/files/1/0207/9406/files/Spoke_GC_Not_Socks.png?v=1588240932',
    'https://cdn.shopify.com/s/files/1/0207/9406/files/Leg_Day_-_Contents_-_1000px_ce179df2-c616-405c-9e6d-4d761c94b710.png?v=1587988319',
    'https://cdn.shopify.com/s/files/1/0207/9406/files/Fit_Happens_-_Contents_-_1000px_da87eb77-cb08-4ee2-8a92-6436e6ea4fcc.png?v=1587988344',
    'https://cdn.shopify.com/s/files/1/0207/9406/files/Spoke_GC_No_Cover_9ebd08df-2ca9-4071-89af-d3e41edcb3d9.jpg?v=1588240962'
  ],
  prices: ['£25.00', '£50.00', '£100.00', '£150.00', '£200.00'],
  values: ['25', '50', '100', '150', '200'],
  radios: [
    // {
    //   step: 'A',
    //   value: 'Not socks',
    //   id: 'not-socks'
    // },
    {
      step: 'A',
      value: "Fit's about to get real",
      id: 'fit-about-to-get-real'
    },
    {
      step: 'B',
      value: "Friends don't let friends...",
      id: 'friend-dont-let-friends'
    },
    {
      step: 'C',
      value: 'I got this gift card because...',
      id: 'got-this-gift-because'
    },
    {
      step: 'D',
      value: 'No outer box',
      id: 'no-outer-box'
    }
  ]
} as const

export const ORDERED_OPTIONS = [
  WAIST,
  BUILD,
  LEG,
  SHORTSLEG,
  SIZE,
  CHEST_SIZE,
  CUT,
  LENGTH,
  TAPER
] as const

export const KLAVIYO_SMS_LIST_IDS = {
  GB: {
    prod: 'UmYUMe',
    dev: 'SeqFpb'
  },
  US: {
    prod: 'XD4fGP',
    dev: 'RCbVbM'
  },
  EU: {
    prod: '',
    dev: ''
  }
} as const

export const KLAVIYO_EMAIL_LIST_IDS = {
  prod: {
    first_tier_marketing: 'PAVDLA'
  },
  dev: {
    first_tier_marketing: 'QptFXT'
  }
} as const

export const LOCALES = {
  GB: 'en-GB',
  US: 'en-US',
  EU: 'en-EU'
} as const

export const CURRENCY_CODES = {
  GB: 'GBP',
  US: 'USD',
  EU: 'EUR'
} as const

export const STORE_ANALYTICS_CODES = {
  uk: 'uk',
  gb: 'uk',
  us: 'us',
  eu: 'eu'
} as const

export const STORES_PHONE_NUMBERS = {
  phone: {
    gb: '0203 735 7814',
    us: '+1 855-658-7760',
    eu: '+44 203 735 7814'
  },
  whatsApp: '442037357814'
} as const

export const STORES_SMS_NUMBERS = {
  phone: {
    gb: '+44 (0) 203 735 7814',
    us: '+1 855-658-7760',
    eu: '+44 (0) 203 735 7814'
  },
  whatsApp: '+44 (0) 203 735 7814'
} as const

export const STORES_HELPDESK_LINKS = {
  gb: 'https://help.spoke-london.com/en',
  us: 'https://help.spoke-london.com/en',
  eu: 'https://help.spoke-london.com/en'
} as const

export const STORE_HELPDESK_OPEN_TIMES = {
  gb: '9-5pm',
  us: '9-5pm',
  eu: '10-6pm'
} as const

export const STATIC_PAGES = [
  { title: 'Colors', handle: '/colors' },
  { title: 'Been referred by a friend?', handle: '/thank-your-friend' },
  { title: 'Contact Us', handle: '/contact-us' },
  { title: 'Fit Finder', handle: '/fit-finder' },
  { title: 'Returns', handle: '/returns' },
  {
    title: 'Tell a friend, earn rewards',
    handle: '/refer-a-friend'
  },
  { title: 'Spoke Feedback', handle: '/spoke-feedback' },
  { title: 'Size Chart (tops)', handle: '/tops-size-chart' },
  { title: 'Size Chart (trousers)', handle: '/trousers-size-chart' },
  { title: 'Size Chart (shorts)', handle: '/shorts-size-chart' },
  { title: 'Size Chart (denim)', handle: '/denim-size-chart' },
  { title: 'Size Chart (underwear)', handle: '/underwear-size-chart' },
  { title: 'Size Chart (accessories)', handle: '/accessories-size-chart' },
  { title: 'Unsubscribe', handle: '/unsubscribe' },
  { title: 'Search', handle: '/search' },
  // Landing Pages
  { title: 'Enduros', handle: '/enduros-range' }
] as const satisfies readonly StaticPageDef[]

export const HEADERS = {
  'x-api-key': process.env.API_KEY
} as const

export const CONTENTFUL_HEADERS_ID = {
  productBreakdownCollection: '2ZOavGHUoBP3AoYrUmORht',
  productBreakdownGiftingCollection: '2xd2p6pt3TpFz6u2uCkuqR',
  productBreakdownProducts: '5RvZs1gCUsbDWUpxvgRA9P'
} as const

export const HIDE_FLASH_BANNER = ['/heroes'] as const

export const PRODUCT_PAGE_BREAKDOWN_MERGE_TYPES = {
  Lightweights: [
    'Cotton Lightweights',
    'Linen Lightweights',
    'Summer Sharps',
    'Linen Sharps'
  ],
  Denim: ['Japanese Denim', '12oz Denim'],
  Fives: ['Cord Fives'],
  Sharps: ['Cord Sharps'],
  Heroes: ['Winter Heroes']
} as const

export const MEDIA_QUERY_BREAKPOINTS = {
  SMALL_MOBILE: 'SMALL_MOBILE',
  TABLET: 'TABLET',
  PHABLET: 'PHABLET',
  TABLET_LARGE: 'TABLET_LARGE',
  // TABLET_PRO: "TABLET_PRO",
  DESKTOP: 'DESKTOP',
  DESKTOP_LARGE: 'DESKTOP_LARGE',
  DESKTOP_EXTRA_LARGE: 'DESKTOP_EXTRA_LARGE',
  TV: 'TV'
} as const

export const BREAKPOINT_SIZES = {
  [MEDIA_QUERY_BREAKPOINTS.SMALL_MOBILE]: 350,
  [MEDIA_QUERY_BREAKPOINTS.TABLET]: 600,
  [MEDIA_QUERY_BREAKPOINTS.PHABLET]: 700,
  [MEDIA_QUERY_BREAKPOINTS.TABLET_LARGE]: 768,
  // [MEDIA_QUERY_BREAKPOINTS.TABLET_PRO]: 1024,
  [MEDIA_QUERY_BREAKPOINTS.DESKTOP]: 1024,
  [MEDIA_QUERY_BREAKPOINTS.DESKTOP_LARGE]: 1281,
  [MEDIA_QUERY_BREAKPOINTS.DESKTOP_EXTRA_LARGE]: 1600
} as const

export const PRODUCT_COLOUR_TAGS = [
  'promo:',
  'auto-discount',
  'low stock',
  'fabric: new season',
  'priority:'
] as const

export const PRODUCT_TYPE_TAGS = [
  'betawear',
  'new product',
  'preorder',
  'organic',
  'priority',
  MTO_TAG
] as const

export const PRODUCT_TYPES_WITHOUT_COLORS = ['Gift Card'] as const

export const SHIPPING_FEES = {
  threshold: {
    GB: {
      cost: '£150',
      value: 150
    },
    US: {
      cost: '', // not used, but type-safe
      value: 0
    },
    EU: {
      cost: '150€',
      value: 150
    }
  }
} as const

export const COOKIE_EXPIRE_14_DAYS = 14
export const COOKIE_EXPIRE_1_MONTH = 30
export const COOKIE_EXPIRE_3_MONTHS = 90
export const COOKIE_EXPIRE_6_MONTHS = 180
export const COOKIE_EXPIRE_1_YEAR = 365

export const DYNAMIC_FILTER_OPTIONS_BY_OPTION_TYPE = [
  'waist',
  'build',
  'leg',
  'taper',
  'shortsleg',
  'swimshortsleg',
  'chest size',
  'cut'
] as const
export const DYNAMIC_FILTER_OPTIONS_BY_PRODUCT_TYPE = [
  'stripe socks',
  'house socks'
] as const

export const FIT_FINDER_HASH = 'fit_finder_open'

export const FLASH_BANNER_HEIGHT = 35

export const ROYAL_MAIL_PARCEL_COLLECT_CARRIER_ID = 330

export const ISO_3166_COUNTRIES = [
  { alpha2: 'AF', alpha3: 'AFG', countryName: 'Afghanistan', prefix: '+93' },
  { alpha2: 'AX', alpha3: 'ALA', countryName: 'Åland Islands', prefix: '+358' },
  { alpha2: 'AL', alpha3: 'ALB', countryName: 'Albania', prefix: '+355' },
  { alpha2: 'DZ', alpha3: 'DZA', countryName: 'Algeria', prefix: '+213' },
  {
    alpha2: 'AS',
    alpha3: 'ASM',
    countryName: 'American Samoa',
    prefix: '+1-684'
  },
  { alpha2: 'AD', alpha3: 'AND', countryName: 'Andorra', prefix: '+376' },
  { alpha2: 'AO', alpha3: 'AGO', countryName: 'Angola', prefix: '+244' },
  { alpha2: 'AI', alpha3: 'AIA', countryName: 'Anguilla', prefix: '+1-264' },
  {
    alpha2: 'AG',
    alpha3: 'ATG',
    countryName: 'Antigua and Barbuda',
    prefix: '+1-268'
  },
  { alpha2: 'AR', alpha3: 'ARG', countryName: 'Argentina', prefix: '+54' },
  { alpha2: 'AM', alpha3: 'ARM', countryName: 'Armenia', prefix: '+374' },
  { alpha2: 'AW', alpha3: 'ABW', countryName: 'Aruba', prefix: '+297' },
  { alpha2: 'AU', alpha3: 'AUS', countryName: 'Australia', prefix: '+61' },
  { alpha2: 'AT', alpha3: 'AUT', countryName: 'Austria', prefix: '+43' },
  { alpha2: 'AZ', alpha3: 'AZE', countryName: 'Azerbaijan', prefix: '+994' },
  { alpha2: 'BS', alpha3: 'BHS', countryName: 'Bahamas', prefix: '+1-242' },
  { alpha2: 'BH', alpha3: 'BHR', countryName: 'Bahrain', prefix: '+973' },
  { alpha2: 'BD', alpha3: 'BGD', countryName: 'Bangladesh', prefix: '+880' },
  { alpha2: 'BB', alpha3: 'BRB', countryName: 'Barbados', prefix: '+1-246' },
  { alpha2: 'BY', alpha3: 'BLR', countryName: 'Belarus', prefix: '+375' },
  { alpha2: 'BE', alpha3: 'BEL', countryName: 'Belgium', prefix: '+32' },
  { alpha2: 'BZ', alpha3: 'BLZ', countryName: 'Belize', prefix: '+501' },
  { alpha2: 'BJ', alpha3: 'BEN', countryName: 'Benin', prefix: '+229' },
  { alpha2: 'BM', alpha3: 'BMU', countryName: 'Bermuda', prefix: '+1-441' },
  { alpha2: 'BT', alpha3: 'BTN', countryName: 'Bhutan', prefix: '+975' },
  {
    alpha2: 'BO',
    alpha3: 'BOL',
    countryName: 'Bolivia (Plurinational State of)',
    prefix: '+591'
  },
  {
    alpha2: 'BQ',
    alpha3: 'BES',
    countryName: 'Bonaire, Sint Eustatius and Saba',
    prefix: '+599'
  },
  {
    alpha2: 'BA',
    alpha3: 'BIH',
    countryName: 'Bosnia and Herzegovina',
    prefix: '+387'
  },
  { alpha2: 'BW', alpha3: 'BWA', countryName: 'Botswana', prefix: '+267' },
  { alpha2: 'BV', alpha3: 'BVT', countryName: 'Bouvet Island', prefix: '' },
  { alpha2: 'BR', alpha3: 'BRA', countryName: 'Brazil', prefix: '+55' },
  {
    alpha2: 'IO',
    alpha3: 'IOT',
    countryName: 'British Indian Ocean Territory',
    prefix: '+246'
  },
  {
    alpha2: 'BN',
    alpha3: 'BRN',
    countryName: 'Brunei Darussalam',
    prefix: '+673'
  },
  { alpha2: 'BG', alpha3: 'BGR', countryName: 'Bulgaria', prefix: '+359' },
  { alpha2: 'BF', alpha3: 'BFA', countryName: 'Burkina Faso', prefix: '+226' },
  { alpha2: 'BI', alpha3: 'BDI', countryName: 'Burundi', prefix: '+257' },
  { alpha2: 'CV', alpha3: 'CPV', countryName: 'Cabo Verde', prefix: '+238' },
  { alpha2: 'KH', alpha3: 'KHM', countryName: 'Cambodia', prefix: '+855' },
  { alpha2: 'CM', alpha3: 'CMR', countryName: 'Cameroon', prefix: '+237' },
  { alpha2: 'CA', alpha3: 'CAN', countryName: 'Canada', prefix: '+1' },
  {
    alpha2: 'KY',
    alpha3: 'CYM',
    countryName: 'Cayman Islands',
    prefix: '+1-345'
  },
  {
    alpha2: 'CF',
    alpha3: 'CAF',
    countryName: 'Central African Republic',
    prefix: '+236'
  },
  { alpha2: 'TD', alpha3: 'TCD', countryName: 'Chad', prefix: '+235' },
  { alpha2: 'CL', alpha3: 'CHL', countryName: 'Chile', prefix: '+56' },
  { alpha2: 'CN', alpha3: 'CHN', countryName: 'China', prefix: '+86' },
  {
    alpha2: 'CX',
    alpha3: 'CXR',
    countryName: 'Christmas Island',
    prefix: '+61'
  },
  {
    alpha2: 'CC',
    alpha3: 'CCK',
    countryName: 'Cocos (Keeling) Islands',
    prefix: '+61'
  },
  { alpha2: 'CO', alpha3: 'COL', countryName: 'Colombia', prefix: '+57' },
  { alpha2: 'KM', alpha3: 'COM', countryName: 'Comoros', prefix: '+269' },
  {
    alpha2: 'CG',
    alpha3: 'COG',
    countryName: 'Congo - Brazzaville',
    prefix: '+242'
  },
  {
    alpha2: 'CD',
    alpha3: 'COD',
    countryName: 'Congo - Kinshasa',
    prefix: '+243'
  },
  { alpha2: 'CK', alpha3: 'COK', countryName: 'Cook Islands', prefix: '+682' },
  { alpha2: 'CR', alpha3: 'CRI', countryName: 'Costa Rica', prefix: '+506' },
  { alpha2: 'HR', alpha3: 'HRV', countryName: 'Croatia', prefix: '+385' },
  { alpha2: 'CU', alpha3: 'CUB', countryName: 'Cuba', prefix: '+53' },
  { alpha2: 'CW', alpha3: 'CUW', countryName: 'Curaçao', prefix: '+599' },
  { alpha2: 'CY', alpha3: 'CYP', countryName: 'Cyprus', prefix: '+357' },
  { alpha2: 'CZ', alpha3: 'CZE', countryName: 'Czechia', prefix: '+420' },
  { alpha2: 'DK', alpha3: 'DNK', countryName: 'Denmark', prefix: '+45' },
  { alpha2: 'DJ', alpha3: 'DJI', countryName: 'Djibouti', prefix: '+253' },
  { alpha2: 'DM', alpha3: 'DMA', countryName: 'Dominica', prefix: '+1-767' },
  {
    alpha2: 'DO',
    alpha3: 'DOM',
    countryName: 'Dominican Republic',
    prefix: '+1-809'
  },
  { alpha2: 'EC', alpha3: 'ECU', countryName: 'Ecuador', prefix: '+593' },
  { alpha2: 'EG', alpha3: 'EGY', countryName: 'Egypt', prefix: '+20' },
  { alpha2: 'SV', alpha3: 'SLV', countryName: 'El Salvador', prefix: '+503' },
  {
    alpha2: 'GQ',
    alpha3: 'GNQ',
    countryName: 'Equatorial Guinea',
    prefix: '+240'
  },
  { alpha2: 'ER', alpha3: 'ERI', countryName: 'Eritrea', prefix: '+291' },
  { alpha2: 'EE', alpha3: 'EST', countryName: 'Estonia', prefix: '+372' },
  { alpha2: 'SZ', alpha3: 'SWZ', countryName: 'Eswatini', prefix: '+268' },
  { alpha2: 'ET', alpha3: 'ETH', countryName: 'Ethiopia', prefix: '+251' },
  {
    alpha2: 'FK',
    alpha3: 'FLK',
    countryName: 'Falkland Islands',
    prefix: '+500'
  },
  { alpha2: 'FO', alpha3: 'FRO', countryName: 'Faroe Islands', prefix: '+298' },
  { alpha2: 'FJ', alpha3: 'FJI', countryName: 'Fiji', prefix: '+679' },
  { alpha2: 'FI', alpha3: 'FIN', countryName: 'Finland', prefix: '+358' },
  { alpha2: 'FR', alpha3: 'FRA', countryName: 'France', prefix: '+33' },
  { alpha2: 'GF', alpha3: 'GUF', countryName: 'French Guiana', prefix: '+594' },
  {
    alpha2: 'PF',
    alpha3: 'PYF',
    countryName: 'French Polynesia',
    prefix: '+689'
  },
  {
    alpha2: 'TF',
    alpha3: 'ATF',
    countryName: 'French Southern Territories',
    prefix: ''
  },
  { alpha2: 'GA', alpha3: 'GAB', countryName: 'Gabon', prefix: '+241' },
  { alpha2: 'GM', alpha3: 'GMB', countryName: 'Gambia', prefix: '+220' },
  { alpha2: 'GE', alpha3: 'GEO', countryName: 'Georgia', prefix: '+995' },
  { alpha2: 'DE', alpha3: 'DEU', countryName: 'Germany', prefix: '+49' },
  { alpha2: 'GH', alpha3: 'GHA', countryName: 'Ghana', prefix: '+233' },
  { alpha2: 'GI', alpha3: 'GIB', countryName: 'Gibraltar', prefix: '+350' },
  { alpha2: 'GR', alpha3: 'GRC', countryName: 'Greece', prefix: '+30' },
  { alpha2: 'GL', alpha3: 'GRL', countryName: 'Greenland', prefix: '+299' },
  { alpha2: 'GD', alpha3: 'GRD', countryName: 'Grenada', prefix: '+1-473' },
  { alpha2: 'GP', alpha3: 'GLP', countryName: 'Guadeloupe', prefix: '+590' },
  { alpha2: 'GU', alpha3: 'GUM', countryName: 'Guam', prefix: '+1-671' },
  { alpha2: 'GT', alpha3: 'GTM', countryName: 'Guatemala', prefix: '+502' },
  { alpha2: 'GG', alpha3: 'GGY', countryName: 'Guernsey', prefix: '+44' },
  { alpha2: 'GN', alpha3: 'GIN', countryName: 'Guinea', prefix: '+224' },
  { alpha2: 'GW', alpha3: 'GNB', countryName: 'Guinea-Bissau', prefix: '+245' },
  { alpha2: 'GY', alpha3: 'GUY', countryName: 'Guyana', prefix: '+592' },
  { alpha2: 'HT', alpha3: 'HTI', countryName: 'Haiti', prefix: '+509' },
  {
    alpha2: 'HM',
    alpha3: 'HMD',
    countryName: 'Heard Island and McDonald Islands',
    prefix: '+672'
  },
  { alpha2: 'HN', alpha3: 'HND', countryName: 'Honduras', prefix: '+504' },
  { alpha2: 'HK', alpha3: 'HKG', countryName: 'Hong Kong SAR', prefix: '+852' },
  { alpha2: 'HU', alpha3: 'HUN', countryName: 'Hungary', prefix: '+36' },
  { alpha2: 'IS', alpha3: 'ISL', countryName: 'Iceland', prefix: '+354' },
  { alpha2: 'IN', alpha3: 'IND', countryName: 'India', prefix: '+91' },
  { alpha2: 'ID', alpha3: 'IDN', countryName: 'Indonesia', prefix: '+62' },
  { alpha2: 'IR', alpha3: 'IRN', countryName: 'Iran', prefix: '+98' },
  { alpha2: 'IQ', alpha3: 'IRQ', countryName: 'Iraq', prefix: '+964' },
  { alpha2: 'IE', alpha3: 'IRL', countryName: 'Ireland', prefix: '+353' },
  { alpha2: 'IM', alpha3: 'IMN', countryName: 'Isle of Man', prefix: '+44' },
  { alpha2: 'IL', alpha3: 'ISR', countryName: 'Israel', prefix: '+972' },
  { alpha2: 'IT', alpha3: 'ITA', countryName: 'Italy', prefix: '+39' },
  { alpha2: 'JM', alpha3: 'JAM', countryName: 'Jamaica', prefix: '+1-876' },
  { alpha2: 'JP', alpha3: 'JPN', countryName: 'Japan', prefix: '+81' },
  { alpha2: 'JE', alpha3: 'JEY', countryName: 'Jersey', prefix: '+44' },
  { alpha2: 'JO', alpha3: 'JOR', countryName: 'Jordan', prefix: '+962' },
  { alpha2: 'KZ', alpha3: 'KAZ', countryName: 'Kazakhstan', prefix: '+7' },
  { alpha2: 'KE', alpha3: 'KEN', countryName: 'Kenya', prefix: '+254' },
  { alpha2: 'KI', alpha3: 'KIR', countryName: 'Kiribati', prefix: '+686' },
  { alpha2: 'XK', alpha3: 'XKX', countryName: 'Kosovo', prefix: '+383' },
  { alpha2: 'KW', alpha3: 'KWT', countryName: 'Kuwait', prefix: '+965' },
  { alpha2: 'KG', alpha3: 'KGZ', countryName: 'Kyrgyzstan', prefix: '+996' },
  { alpha2: 'LA', alpha3: 'LAO', countryName: 'Laos', prefix: '+856' },
  { alpha2: 'LV', alpha3: 'LVA', countryName: 'Latvia', prefix: '+371' },
  { alpha2: 'LB', alpha3: 'LBN', countryName: 'Lebanon', prefix: '+961' },
  { alpha2: 'LS', alpha3: 'LSO', countryName: 'Lesotho', prefix: '+266' },
  { alpha2: 'LR', alpha3: 'LBR', countryName: 'Liberia', prefix: '+231' },
  { alpha2: 'LY', alpha3: 'LBY', countryName: 'Libya', prefix: '+218' },
  { alpha2: 'LI', alpha3: 'LIE', countryName: 'Liechtenstein', prefix: '+423' },
  { alpha2: 'LT', alpha3: 'LTU', countryName: 'Lithuania', prefix: '+370' },
  { alpha2: 'LU', alpha3: 'LUX', countryName: 'Luxembourg', prefix: '+352' },
  { alpha2: 'MO', alpha3: 'MAC', countryName: 'Macao SAR', prefix: '+853' },
  { alpha2: 'MG', alpha3: 'MDG', countryName: 'Madagascar', prefix: '+261' },
  { alpha2: 'MW', alpha3: 'MWI', countryName: 'Malawi', prefix: '+265' },
  { alpha2: 'MY', alpha3: 'MYS', countryName: 'Malaysia', prefix: '+60' },
  { alpha2: 'MV', alpha3: 'MDV', countryName: 'Maldives', prefix: '+960' },
  { alpha2: 'ML', alpha3: 'MLI', countryName: 'Mali', prefix: '+223' },
  { alpha2: 'MT', alpha3: 'MLT', countryName: 'Malta', prefix: '+356' },
  { alpha2: 'MQ', alpha3: 'MTQ', countryName: 'Martinique', prefix: '+596' },
  { alpha2: 'MR', alpha3: 'MRT', countryName: 'Mauritania', prefix: '+222' },
  { alpha2: 'MU', alpha3: 'MUS', countryName: 'Mauritius', prefix: '+230' },
  { alpha2: 'YT', alpha3: 'MYT', countryName: 'Mayotte', prefix: '+262' },
  { alpha2: 'MX', alpha3: 'MEX', countryName: 'Mexico', prefix: '+52' },
  { alpha2: 'MD', alpha3: 'MDA', countryName: 'Moldova', prefix: '+373' },
  { alpha2: 'MC', alpha3: 'MCO', countryName: 'Monaco', prefix: '+377' },
  { alpha2: 'MN', alpha3: 'MNG', countryName: 'Mongolia', prefix: '+976' },
  { alpha2: 'ME', alpha3: 'MNE', countryName: 'Montenegro', prefix: '+382' },
  { alpha2: 'MS', alpha3: 'MSR', countryName: 'Montserrat', prefix: '+1-664' },
  { alpha2: 'MA', alpha3: 'MAR', countryName: 'Morocco', prefix: '+212' },
  { alpha2: 'MZ', alpha3: 'MOZ', countryName: 'Mozambique', prefix: '+258' },
  {
    alpha2: 'MM',
    alpha3: 'MMR',
    countryName: 'Myanmar (Burma)',
    prefix: '+95'
  },
  { alpha2: 'NA', alpha3: 'NAM', countryName: 'Namibia', prefix: '+264' },
  { alpha2: 'NR', alpha3: 'NRU', countryName: 'Nauru', prefix: '+674' },
  { alpha2: 'NP', alpha3: 'NPL', countryName: 'Nepal', prefix: '+977' },
  { alpha2: 'NL', alpha3: 'NLD', countryName: 'Netherlands', prefix: '+31' },
  { alpha2: 'NC', alpha3: 'NCL', countryName: 'New Caledonia', prefix: '+687' },
  { alpha2: 'NZ', alpha3: 'NZL', countryName: 'New Zealand', prefix: '+64' },
  { alpha2: 'NI', alpha3: 'NIC', countryName: 'Nicaragua', prefix: '+505' },
  { alpha2: 'NE', alpha3: 'NER', countryName: 'Niger', prefix: '+227' },
  { alpha2: 'NG', alpha3: 'NGA', countryName: 'Nigeria', prefix: '+234' },
  { alpha2: 'NU', alpha3: 'NIU', countryName: 'Niue', prefix: '+683' },
  {
    alpha2: 'NF',
    alpha3: 'NFK',
    countryName: 'Norfolk Island',
    prefix: '+672'
  },
  {
    alpha2: 'MK',
    alpha3: 'MKD',
    countryName: 'North Macedonia',
    prefix: '+389'
  },
  { alpha2: 'KP', alpha3: 'PRK', countryName: 'North Korea', prefix: '+850' },
  { alpha2: 'NO', alpha3: 'NOR', countryName: 'Norway', prefix: '+47' },
  { alpha2: 'OM', alpha3: 'OMN', countryName: 'Oman', prefix: '+968' },
  { alpha2: 'PK', alpha3: 'PAK', countryName: 'Pakistan', prefix: '+92' },
  {
    alpha2: 'PS',
    alpha3: 'PSE',
    countryName: 'Palestinian Territories',
    prefix: '+970'
  },
  { alpha2: 'PA', alpha3: 'PAN', countryName: 'Panama', prefix: '+507' },
  {
    alpha2: 'PG',
    alpha3: 'PNG',
    countryName: 'Papua New Guinea',
    prefix: '+675'
  },
  { alpha2: 'PY', alpha3: 'PRY', countryName: 'Paraguay', prefix: '+595' },
  { alpha2: 'PE', alpha3: 'PER', countryName: 'Peru', prefix: '+51' },
  { alpha2: 'PH', alpha3: 'PHL', countryName: 'Philippines', prefix: '+63' },
  {
    alpha2: 'PN',
    alpha3: 'PCN',
    countryName: 'Pitcairn Islands',
    prefix: '+870'
  },
  { alpha2: 'PL', alpha3: 'POL', countryName: 'Poland', prefix: '+48' },
  { alpha2: 'PT', alpha3: 'PRT', countryName: 'Portugal', prefix: '+351' },
  { alpha2: 'QA', alpha3: 'QAT', countryName: 'Qatar', prefix: '+974' },
  { alpha2: 'RE', alpha3: 'REU', countryName: 'Réunion', prefix: '+262' },
  { alpha2: 'RO', alpha3: 'ROU', countryName: 'Romania', prefix: '+40' },
  { alpha2: 'RU', alpha3: 'RUS', countryName: 'Russia', prefix: '+7' },
  { alpha2: 'RW', alpha3: 'RWA', countryName: 'Rwanda', prefix: '+250' },
  { alpha2: 'WS', alpha3: 'WSM', countryName: 'Samoa', prefix: '+685' },
  { alpha2: 'SM', alpha3: 'SMR', countryName: 'San Marino', prefix: '+378' },
  {
    alpha2: 'ST',
    alpha3: 'STP',
    countryName: 'São Tomé & Príncipe',
    prefix: '+239'
  },
  { alpha2: 'SA', alpha3: 'SAU', countryName: 'Saudi Arabia', prefix: '+966' },
  { alpha2: 'SN', alpha3: 'SEN', countryName: 'Senegal', prefix: '+221' },
  { alpha2: 'RS', alpha3: 'SRB', countryName: 'Serbia', prefix: '+381' },
  { alpha2: 'SC', alpha3: 'SYC', countryName: 'Seychelles', prefix: '+248' },
  { alpha2: 'SL', alpha3: 'SLE', countryName: 'Sierra Leone', prefix: '+232' },
  { alpha2: 'SG', alpha3: 'SGP', countryName: 'Singapore', prefix: '+65' },
  {
    alpha2: 'SX',
    alpha3: 'SXM',
    countryName: 'Sint Maarten',
    prefix: '+1-721'
  },
  { alpha2: 'SK', alpha3: 'SVK', countryName: 'Slovakia', prefix: '+421' },
  { alpha2: 'SI', alpha3: 'SVN', countryName: 'Slovenia', prefix: '+386' },
  {
    alpha2: 'SB',
    alpha3: 'SLB',
    countryName: 'Solomon Islands',
    prefix: '+677'
  },
  { alpha2: 'SO', alpha3: 'SOM', countryName: 'Somalia', prefix: '+252' },
  { alpha2: 'ZA', alpha3: 'ZAF', countryName: 'South Africa', prefix: '+27' },
  {
    alpha2: 'GS',
    alpha3: 'SGS',
    countryName: 'South Georgia & South Sandwich Islands',
    prefix: '+500'
  },
  { alpha2: 'KR', alpha3: 'KOR', countryName: 'South Korea', prefix: '+82' },
  { alpha2: 'SS', alpha3: 'SSD', countryName: 'South Sudan', prefix: '+211' },
  { alpha2: 'ES', alpha3: 'ESP', countryName: 'Spain', prefix: '+34' },
  { alpha2: 'LK', alpha3: 'LKA', countryName: 'Sri Lanka', prefix: '+94' },
  {
    alpha2: 'BL',
    alpha3: 'BLM',
    countryName: 'St. Barthélemy',
    prefix: '+590'
  },
  { alpha2: 'SH', alpha3: 'SHN', countryName: 'St. Helena', prefix: '+290' },
  {
    alpha2: 'KN',
    alpha3: 'KNA',
    countryName: 'St. Kitts & Nevis',
    prefix: '+1-869'
  },
  { alpha2: 'LC', alpha3: 'LCA', countryName: 'St. Lucia', prefix: '+1-758' },
  { alpha2: 'MF', alpha3: 'MAF', countryName: 'St. Martin', prefix: '+590' },
  {
    alpha2: 'PM',
    alpha3: 'SPM',
    countryName: 'St. Pierre & Miquelon',
    prefix: '+508'
  },
  {
    alpha2: 'VC',
    alpha3: 'VCT',
    countryName: 'St. Vincent & Grenadines',
    prefix: '+1-784'
  },
  { alpha2: 'SD', alpha3: 'SDN', countryName: 'Sudan', prefix: '+249' },
  { alpha2: 'SR', alpha3: 'SUR', countryName: 'Suriname', prefix: '+597' },
  { alpha2: 'SE', alpha3: 'SWE', countryName: 'Sweden', prefix: '+46' },
  { alpha2: 'CH', alpha3: 'CHE', countryName: 'Switzerland', prefix: '+41' },
  { alpha2: 'SY', alpha3: 'SYR', countryName: 'Syria', prefix: '+963' },
  { alpha2: 'TW', alpha3: 'TWN', countryName: 'Taiwan', prefix: '+886' },
  { alpha2: 'TJ', alpha3: 'TJK', countryName: 'Tajikistan', prefix: '+992' },
  { alpha2: 'TZ', alpha3: 'TZA', countryName: 'Tanzania', prefix: '+255' },
  { alpha2: 'TH', alpha3: 'THA', countryName: 'Thailand', prefix: '+66' },
  { alpha2: 'TL', alpha3: 'TLS', countryName: 'Timor-Leste', prefix: '+670' },
  { alpha2: 'TG', alpha3: 'TGO', countryName: 'Togo', prefix: '+228' },
  { alpha2: 'TK', alpha3: 'TKL', countryName: 'Tokelau', prefix: '+690' },
  { alpha2: 'TO', alpha3: 'TON', countryName: 'Tonga', prefix: '+676' },
  {
    alpha2: 'TT',
    alpha3: 'TTO',
    countryName: 'Trinidad & Tobago',
    prefix: '+1-868'
  },
  {
    alpha2: 'TA',
    alpha3: 'TAA',
    countryName: 'Tristan da Cunha',
    prefix: '+290'
  },
  { alpha2: 'TN', alpha3: 'TUN', countryName: 'Tunisia', prefix: '+216' },
  { alpha2: 'TR', alpha3: 'TUR', countryName: 'Turkey', prefix: '+90' },
  { alpha2: 'TM', alpha3: 'TKM', countryName: 'Turkmenistan', prefix: '+993' },
  {
    alpha2: 'TC',
    alpha3: 'TCA',
    countryName: 'Turks & Caicos Islands',
    prefix: '+1-649'
  },
  { alpha2: 'TV', alpha3: 'TUV', countryName: 'Tuvalu', prefix: '+688' },
  { alpha2: 'UG', alpha3: 'UGA', countryName: 'Uganda', prefix: '+256' },
  { alpha2: 'UA', alpha3: 'UKR', countryName: 'Ukraine', prefix: '+380' },
  {
    alpha2: 'AE',
    alpha3: 'ARE',
    countryName: 'United Arab Emirates',
    prefix: '+971'
  },
  { alpha2: 'GB', alpha3: 'GBR', countryName: 'United Kingdom', prefix: '+44' },
  {
    alpha2: 'UM',
    alpha3: 'UMI',
    countryName: 'United States Minor Outlying Islands',
    prefix: '+1'
  },
  { alpha2: 'US', alpha3: 'USA', countryName: 'United States', prefix: '+1' },
  { alpha2: 'UY', alpha3: 'URY', countryName: 'Uruguay', prefix: '+598' },
  { alpha2: 'UZ', alpha3: 'UZB', countryName: 'Uzbekistan', prefix: '+998' },
  { alpha2: 'VU', alpha3: 'VUT', countryName: 'Vanuatu', prefix: '+678' },
  { alpha2: 'VA', alpha3: 'VAT', countryName: 'Vatican City', prefix: '+379' },
  { alpha2: 'VE', alpha3: 'VEN', countryName: 'Venezuela', prefix: '+58' },
  { alpha2: 'VN', alpha3: 'VNM', countryName: 'Vietnam', prefix: '+84' },
  {
    alpha2: 'VG',
    alpha3: 'VGB',
    countryName: 'Virgin Islands, British',
    prefix: '+1-284'
  },
  {
    alpha2: 'VI',
    alpha3: 'VIR',
    countryName: 'Virgin Islands, U.S.',
    prefix: '+1-340'
  },
  {
    alpha2: 'WF',
    alpha3: 'WLF',
    countryName: 'Wallis & Futuna',
    prefix: '+681'
  },
  {
    alpha2: 'EH',
    alpha3: 'ESH',
    countryName: 'Western Sahara',
    prefix: '+212'
  },
  { alpha2: 'YE', alpha3: 'YEM', countryName: 'Yemen', prefix: '+967' },
  { alpha2: 'ZM', alpha3: 'ZMB', countryName: 'Zambia', prefix: '+260' },
  { alpha2: 'ZW', alpha3: 'ZWE', countryName: 'Zimbabwe', prefix: '+263' }
]

export const DEFAULT_LINE_ITEM_IMAGE =
  '/static/svgs/illustration/no-product-image.svg'

export const EMPTY_FIELD_VALUE = htmr(`&mdash;`)
